import React from 'react'

const keyEscape = 'escape'
const keyEnter = 'enter'
const keyA = 'a'

type CreatorProcessKeyDownProps = {
  onCancel: () => void
  onEnter: () => void
  refTextarea?: React.MutableRefObject<HTMLTextAreaElement>
}

export const creatorProcessKeyDown =
  (props: CreatorProcessKeyDownProps) =>
  (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    const {onCancel, onEnter, refTextarea} = props
    const eventKey = event.key.toLocaleLowerCase()

    if (eventKey === keyEscape) {
      event.stopPropagation()
      event.preventDefault()
      onCancel()
      return
    }

    if (eventKey === keyEnter) {
      event.stopPropagation()

      if (!event.ctrlKey && !event.metaKey && !event.shiftKey) {
        event.preventDefault()
        onEnter()
      }
      return
    }

    if (eventKey === keyA && (event.ctrlKey || event.metaKey)) {
      refTextarea?.current?.select()
    }
  }
